import { useMemo } from "react";
import { useAppDispatch, useRootState } from "./index";
import { bindActionCreators } from "redux";
import {
  trunkGetManageType,
  trunkCreateManageType,
  trunkUpdateManageType,
  trunkDeleteManageType,
  trunkGetAssingment,
  trunkCreateAssignment,
  trunkUpdateAssignment,
  trunkDeleteAssignment,
} from "../store/admin/adminSetting";

const useAdminLoginStore = () => {
  const adminSettingState = useRootState((state) => state.adminSettingStore);

  const dispatch = useAppDispatch();

  const boundGetManageType = useMemo(
    () => bindActionCreators(trunkGetManageType, dispatch),
    [dispatch]
  );
  const boundCreateManageType = useMemo(
    () => bindActionCreators(trunkCreateManageType, dispatch),
    [dispatch]
  );
  const boundUpdateManageType = useMemo(
    () => bindActionCreators(trunkUpdateManageType, dispatch),
    [dispatch]
  );
  const boundDeleteManageType = useMemo(
    () => bindActionCreators(trunkDeleteManageType, dispatch),
    [dispatch]
  );
  const boundGetAssingment = useMemo(
    () => bindActionCreators(trunkGetAssingment, dispatch),
    [dispatch]
  );
  const boundCreateAssignment = useMemo(
    () => bindActionCreators(trunkCreateAssignment, dispatch),
    [dispatch]
  );
  const boundUpdateAssignment = useMemo(
    () => bindActionCreators(trunkUpdateAssignment, dispatch),
    [dispatch]
  );
  const boundDeleteAssignment = useMemo(
    () => bindActionCreators(trunkDeleteAssignment, dispatch),
    [dispatch]
  );

  return {
    adminSettingState,
    getManageType: boundGetManageType,
    createManageType: boundCreateManageType,
    updateManageType: boundUpdateManageType,
    deleteManageType: boundDeleteManageType,
    getAssingment: boundGetAssingment,
    createAssignment: boundCreateAssignment,
    updateAssignment: boundUpdateAssignment,
    deleteAssignment: boundDeleteAssignment,
  };
};

export default useAdminLoginStore;
